import { useLocalStorage } from "../../../../utils/useLocalStorage";
import { CLOUD_MATURITY_ENABLED_LOCAL_STORAGE_KEY } from "../types";

export const useCloudMaturity = () => {
  const [isCloudMaturityEnabled, setIsCloudMaturityEnabled] =
    useLocalStorage<boolean>(CLOUD_MATURITY_ENABLED_LOCAL_STORAGE_KEY, false);

  return {
    isCloudMaturityEnabled,
    setIsCloudMaturityEnabled,
  };
};
